import { useLocation, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items?: BreadcrumbItem[];
}

const routeLabelMap: Record<string, string> = {
  '': '首页',
  'category': '分类',
  'article': '文章',
  'about': '关于我们',
  'tiaozhuan-fangfa': '跳转方法',
  'zuixin-dizhi': '最新地址',
  'fangwen-jiaocheng': '访问教程',
  'changjian-wenti': '常见问题',
  'pingtai-zixun': '平台资讯',
};

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();
  const [crumbs, setCrumbs] = useState<BreadcrumbItem[]>([]);

  useEffect(() => {
    if (items) {
      setCrumbs(items);
      return;
    }

    const pathSegments = location.pathname.split('/').filter(Boolean);
    const generated: BreadcrumbItem[] = [{ label: '首页', path: '/' }];

    let currentPath = '';
    pathSegments.forEach((segment) => {
      currentPath += `/${segment}`;
      const label = routeLabelMap[segment] || segment;
      generated.push({ label, path: currentPath });
    });

    setCrumbs(generated);
  }, [location.pathname, items]);

  return (
    <nav aria-label="面包屑导航" className="container-site py-3">
      <ol className="flex flex-wrap items-center gap-1 text-sm text-foreground-500">
        {crumbs.map((crumb, index) => (
          <li key={index} className="flex items-center gap-1">
            {index > 0 && (
              <span className="text-foreground-300 mx-1" aria-hidden="true">/</span>
            )}
            {crumb.path && index < crumbs.length - 1 ? (
              <Link
                to={crumb.path}
                className="text-accent-600 hover:text-accent-700 transition-colors duration-200 whitespace-nowrap"
              >
                {crumb.label}
              </Link>
            ) : (
              <span className={index === crumbs.length - 1 ? 'text-foreground-800 font-medium' : 'text-foreground-500'}>
                {crumb.label}
              </span>
            )}
          </li>
        ))}
      </ol>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: crumbs.map((crumb, index) => ({
              '@type': 'ListItem',
              position: index + 1,
              name: crumb.label,
              item: crumb.path ? `https://baoyutv-tiaozhuan.com${crumb.path}` : undefined,
            })),
          }),
        }}
      />
    </nav>
  );
}